import { createAction, props, union } from '@ngrx/store';

import { UpcomingTrip } from '../../interfaces/upcoming-trips.interface';
import { UpcomingTripsFetchStatus } from '../../interfaces/store.interface';

export const setTrips = createAction(
  '[PnrWidget] SetTrips',
  props<{ trips: UpcomingTrip[]; status: UpcomingTripsFetchStatus }>()
);
export const fetchTrips = createAction('[PnrWidget] FetchTrips');

const _all = union({ setTrips, fetchTrips });

export type UpcomingTripsActionsUnion = typeof _all;
